(function () {
  function pickMoneyNode(card, rootSelector) {
    var root = card.querySelector(rootSelector);
    if (!root) return null;
    return root.querySelector('[data-ymq-money]') || root.querySelector('[ymq-b2b-money]') || root;
  }

  function readNumberFromText(t) {
    if (!t) return null;
    var m = String(t).replace(/\s+/g, ' ').match(/[-]?\d+(?:[.,]\d+)?/);
    if (!m) return null;
    var n = parseFloat(m[0].replace(',', '.'));
    if (isNaN(n)) return null;
    return n;
  }

  function toCentsFromNode(node) {
    if (!node) return null;

    var a = node.getAttribute('data-ymq-money');
    if (a != null && a !== '') {
      var n1 = parseFloat(String(a).replace(',', '.'));
      if (!isNaN(n1)) return Math.round(n1 * 100);
    }

    var b = node.getAttribute('ymq-b2b-money');
    if (b != null && b !== '') {
      var n2 = parseFloat(String(b).replace(',', '.'));
      if (!isNaN(n2)) return Math.round(n2 * 100);
    }

    var n3 = readNumberFromText(node.textContent || '');
    if (n3 == null) return null;
    return Math.round(n3 * 100);
  }

  function formatLike(exampleText, cents) {
    if (!exampleText) exampleText = '';
    var hasComma = exampleText.indexOf(',') !== -1;
    var num = (cents / 100).toFixed(2);
    if (hasComma) num = num.replace('.', ',');

    var currency = exampleText
      .replace(/[0-9\s.,\-]/g, '')
      .replace(/^kr\s*/i, '')
      .trim();

    var prefix = exampleText.trim().toLowerCase().startsWith('kr') ? 'kr ' : '';
    return prefix + num + (currency ? (' ' + currency) : '');
  }

  function applyPercent(baseCents, multiplierBp) {
    return Math.max(0, Math.round(baseCents * (multiplierBp / 10000)));
  }

  function applyAmount(baseCents, discountCents) {
    return Math.max(0, baseCents - discountCents);
  }

  function updateOne(box) {
var card =
  box.closest('.productitem__container') ||
  box.closest('.productitem') ||
  box.closest('.product-block--price') ||
  box.closest('.search-flydown--product') ||
  box.closest('li') ||
  document;

    if (!card) return false;

    var exNode = pickMoneyNode(card, '.ymq-b2b-exc-vat-price');
    var incNode = pickMoneyNode(card, '.ymq-b2b-inc-vat-price');
    if (!exNode || !incNode) return false;

    var exBase = toCentsFromNode(exNode);
    var incBase = toCentsFromNode(incNode);
    if (exBase == null || incBase == null) return false;

    var exText = (exNode.textContent || '').trim();
    var incText = (incNode.textContent || '').trim();

    var isPercent = box.getAttribute('data-is-percent') === '1';
    var isAmount = box.getAttribute('data-is-amount') === '1';

    var multiplierBp = parseInt(box.getAttribute('data-multiplier-bp') || '10000', 10);
    var discountSek = parseFloat((box.getAttribute('data-discount-sek') || '0').replace(',', '.')) || 0;
    var baseSekCents = parseInt(box.getAttribute('data-base-sek-cents') || '0', 10);

    var exNew, incNew;

    if (isPercent) {
      exNew = applyPercent(exBase, multiplierBp);
      incNew = applyPercent(incBase, multiplierBp);
    } else if (isAmount) {
      var sekDiscountCents = Math.round(discountSek * 100);

      var fx = 1;
      if (baseSekCents > 0) fx = incBase / baseSekCents;

      var incDiscount = Math.round(sekDiscountCents * fx);
      var vatRatio = incBase > 0 ? (exBase / incBase) : 1;
      var exDiscount = Math.round(incDiscount * vatRatio);

      exNew = applyAmount(exBase, exDiscount);
      incNew = applyAmount(incBase, incDiscount);
    } else {
      return false;
    }

    var exOut = box.querySelector('.js-justnu-ex');
    var incOut = box.querySelector('.js-justnu-inc');

    if (exOut) exOut.textContent = formatLike(exText, exNew);
    if (incOut) incOut.textContent = formatLike(incText, incNew);

    box.setAttribute('data-geofix-ok', '1');
    return true;
  }

  function updateAll() {
    document.querySelectorAll('.geofix-discount-preview').forEach(function (box) {
      if (box.getAttribute('data-geofix-ok') === '1') return;
      updateOne(box);
    });
  }

  function boot() {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      updateAll();
      if (tries > 120) clearInterval(t);
    }, 250);

    var mo = new MutationObserver(function () { updateAll(); });
    mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, characterData: true });
  }

  try { boot(); } catch (e) {}
})();
